type StringOrNumber = string | number;

type DictionaryType = Array<{ id: StringOrNumber; name: string }>;

const nameFromDictionary = (
  Dictionary: DictionaryType,
  Indicator: StringOrNumber,
): string => {
  if (!(Array.isArray(Dictionary) && Dictionary.length > 0) || !Indicator)
    return '';
  const result = Dictionary.find(
    ({ id }) => id.toString() === Indicator.toString(),
  );
  return result && result.name ? result.name : '';
};

export default nameFromDictionary;



// WEBPACK FOOTER //
// ./src/tools/nameFromDictionary.ts